import styled from '@emotion/styled';
import React, { FC } from 'react';
import QuestionModal from '~ComponentsImproved/QuestionModal';
import { useButton, useI18n } from '~Hooks';
import { handyBreakpoint } from '~Styles/breakpoints';

const Wrapper = styled.div<{ isSelected: boolean; touching?: boolean; isDisabled: boolean }>`
  background-color: ${({ isSelected, isDisabled }) =>
    isDisabled
      ? 'var(--colorBlueGray500)'
      : isSelected
      ? 'var(--colorUIGreen)'
      : 'var(--colorWhite)'};
  color: ${({ isSelected, isDisabled }) =>
    isDisabled
      ? 'var(--colorBlueGray800)'
      : isSelected
      ? 'var(--colorWhite)'
      : 'var(--colorBlack)'};
  width: auto;
  height: 56px;
  padding: 0 24px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${({ touching }) => (touching ? 'scale(0.96)' : '1')};
  transition: transform 0.1s ease-out, opacity 0.1s ease-in-out;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Eina01', 'HelveticaNeue', Helvetica, Arial, sans-serif;
  box-sizing: border-box;

  ${handyBreakpoint} {
    height: 40px;
    padding: 0 16px;
  }
`;

interface Props {
  message: string;
  setSelectedMessage: (message: string) => void;
  isSelected: boolean;
  isDisabled?: boolean;
}

const PredefinedMessageButton: FC<Props> = ({
  message,
  setSelectedMessage,
  isSelected,
  isDisabled = false,
}) => {
  const { i18n } = useI18n();
  const [showQuestionModal, setShowQuestionModal] = React.useState(false);

  const button = useButton({
    onClick: () => (!isDisabled ? setSelectedMessage(message) : setShowQuestionModal(true)),
  });

  return (
    <>
      <Wrapper {...button} isSelected={isSelected} isDisabled={isDisabled}>
        {message}
      </Wrapper>
      <QuestionModal
        question={i18n('Question.Message.AlreadySent')}
        isShowing={showQuestionModal}
        onLeftClick={() => setShowQuestionModal(false)}
        onRightClick={() => {
          setShowQuestionModal(false);
          setSelectedMessage(message);
        }}
        backdropClose={() => setShowQuestionModal(false)}
      />{' '}
    </>
  );
};

export default PredefinedMessageButton;
